import { lazyLoad } from 'utils/loadable';

export const CareerPlanningListPage = lazyLoad(
  () => import('./index'),
  module => module.CareerPlanningListPage,
);
